import React from 'react';
import { Building2 } from 'lucide-react';

export const billingDiffers = (order) => {
  const b = order?.billing_info, s = order?.shipping_info || {};
  if (!b) return false;
  if (b.company || b.vat_number) return true;
  return ['firstName', 'lastName', 'address', 'addressComplement', 'postalCode', 'city'].some(k => (b[k] || '').trim().toLowerCase() !== (s[k] || '').trim().toLowerCase());
};

// Billing address block, shown only when it differs from the delivery address
const BillingAddress = ({ order, className = '' }) => {
  if (!billingDiffers(order)) return null;
  const b = order.billing_info;
  return (
    <div className={className} data-testid="order-billing-address">
      <p className="text-xs font-medium text-gray-500 mb-1 flex items-center gap-1"><Building2 size={12} /> Adresse de facturation</p>
      <p className="text-sm text-gray-900">
        {b.company && <><strong>{b.company}</strong><br /></>}
        {b.firstName} {b.lastName}<br />
        {b.address}{b.addressComplement ? `, ${b.addressComplement}` : ''}<br />
        {b.postalCode} {b.city}, {b.country || 'France'}
        {b.vat_number && <><br /><span className="text-xs text-gray-500">TVA {b.vat_number}</span></>}
      </p>
    </div>
  );
};

export default BillingAddress;
